import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { routerMiddleware } from 'react-router-redux';
import { simpleIsoFetchThunk } from 'simple-iso-fetch';

let store = null;

export function getState() {
  if (store) {
    return store.getState();
  }
}

export function configureStore(history, simpleFetch, initialState) {
  let finalCreateStore;

  if (!process.env.CLIENT || process.env.NODE_ENV === 'production') {
    finalCreateStore = applyMiddleware(simpleIsoFetchThunk(simpleFetch), thunk, routerMiddleware(history))(createStore);
  } else {
    const persistState = require('redux-devtools').persistState,
          DevTools = require('../DevTools').default;

    finalCreateStore = compose(
      applyMiddleware(simpleIsoFetchThunk(simpleFetch), thunk, routerMiddleware(history)),
      window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), // only put in DevTools if user does not have redux devtools chrome extension installed
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
    )(createStore);
  }

  store = finalCreateStore(rootReducer, initialState);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers');
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./shared/redux/store/configureStore.js